import { ShipmentQuoting } from '../../models/shipment-quoting';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';
import { selectShipmentEditorId } from '../shipment-editor/shipment-editor.state';

export interface QuoteProgressState {
    shipments: ShipmentQuoting[];
    focusedQuoteId: string;
    startPendingFor: string|null;
}

export const selectQuotingProgressState = (state: AppState) => state.quoteProgress;

export const selectQuotingEditorActive = createSelector(
    selectQuotingProgressState,
    selectShipmentEditorId,
    (state, id) => state.shipments.filter(s => s.shipmentId === id && !s.completed).length > 0
);

export const selectQuotingProgressCurrent = createSelector(
    selectQuotingProgressState,
    selectShipmentEditorId,
    (state, id) => state.shipments.find(s => s.shipmentId === id)
);

export const selectQuotingActiveIds = createSelector(selectQuotingProgressState,
    (state: QuoteProgressState) => state.shipments.map(s => s.shipmentId));

export const selectQuotingActiveShipments = createSelector(selectQuotingProgressState,
    (state: QuoteProgressState) => state.shipments);

export const selectFocusedQuoteId = createSelector(selectQuotingProgressState,
    (state: QuoteProgressState) => state.focusedQuoteId);

export const selectQuotingPendingSave = createSelector(selectQuotingProgressState,
    (state: QuoteProgressState) => state.startPendingFor);

export const shipmentQuotingProgress = (shipmentId: string) => createSelector(selectQuotingProgressState,
    (state: QuoteProgressState) => state.shipments.find(s => s.shipmentId === shipmentId));

export const selectQuotingMessages = (shipmentId: string) => createSelector(selectQuotingProgressState,
    (state: QuoteProgressState) => state.shipments
        .filter(s => s.shipmentId === shipmentId)
        .map(s => s.messages)
        .flat());
